"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../Icon"));
var Link_1 = __importDefault(require("../Link"));
var LogoLink = Link_1.default;
function ResponsiveLogo(props) {
    var _a = props.type, type = _a === void 0 ? 'DYNAMIC' : _a, _b = props.logoLink, logoLink = _b === void 0 ? '/' : _b;
    var iconColor = props.colorTheme === 'DARK' ? 'white' : 'black';
    var fullLogo = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(LogoLink, { href: logoLink, display: type === 'DYNAMIC' ? { _: 'none', lg: 'block' } : undefined },
            react_1.default.createElement(Icon_1.default, { name: "ff-icon-logo-full-black", fontSize: '28px', color: iconColor, display: 'block' }))));
    var simpleLogo = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(LogoLink, { href: logoLink, display: type === 'DYNAMIC' ? { _: 'block', lg: 'none' } : undefined },
            react_1.default.createElement(Icon_1.default, { name: "ff-icon-logo-2", fontSize: { _: '30px', md: '43px' }, color: iconColor, display: 'block' }))));
    if (type === 'FULL') {
        return fullLogo;
    }
    if (type === 'SIMPLE') {
        return simpleLogo;
    }
    // DYNAMIC
    return (react_1.default.createElement(react_1.default.Fragment, null,
        fullLogo,
        simpleLogo));
}
exports.default = ResponsiveLogo;
